export enum SensorType {
  FILL_LEVEL = 'FILL_LEVEL',
  TEMPERATURE = 'TEMPERATURE',
  HUMIDITY = 'HUMIDITY',
  COMPOSITE = 'COMPOSITE'
}

export enum SensorStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  MAINTENANCE = 'MAINTENANCE',
  ERROR = 'ERROR'
}

export interface SensorSchema {
  id: string;
  name: string;
  type: SensorType;
  status: SensorStatus;
  serial_number: string;
  model: string;
  manufacturer: string;
  installation_date: string;
  last_calibration_date?: string;
  next_calibration_date?: string;
  battery_level?: number;
  signal_strength?: number;
  container_id?: string;
  last_reading?: {
    timestamp: string;
    value: number;
    unit: string;
  };
  organization_id: string;
  created_at: string;
  updated_at: string;
}

export interface SensorRequest {
  name: string;
  type: SensorType;
  serial_number: string;
  model: string;
  manufacturer: string;
  installation_date: string;
  container_id?: string;
  organization_id: string;
}

export interface UpdateSensorRequest {
  name?: string;
  type?: SensorType;
  status?: SensorStatus;
  last_calibration_date?: string;
  next_calibration_date?: string;
  container_id?: string;
}

export interface SensorQueryParams {
  page?: number;
  limit?: number;
  type?: SensorType;
  status?: SensorStatus;
  search?: string;
}

export interface PaginatedSensorResponse {
  sensors: SensorSchema[];
  total: number;
}

export interface SensorReading {
  sensor_id: string;
  timestamp: string;
  value: number;
  unit: string;
  metadata?: {
    battery_level?: number;
    signal_strength?: number;
    temperature?: number;
    humidity?: number;
  };
} 